import call from './call';
import {GET_NEW_REQUEST_FIELDS} from "../types";

export default (onFinishCallBack) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            if(onFinishCallBack)
                onFinishCallBack(result[1].results);
            dispatch({type: GET_NEW_REQUEST_FIELDS, payload: {fields: result[1].results}});
        }

    };
    dispatch(call("SystemService/getAllFields",{},onResult));
};